module.exports = __webpack_public_path__ + "static/media/badge7.9fe0ba5e.svg";